const staticPixels = "\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-WQTZ3MKC78&l=dataLayer\"></script>";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING"];

export { staticPixels };
export { pixelsCategories };